import './MainComponent.css';
import React, { useState, useContext, lazy, Suspense, useEffect, useRef, createRef } from "react";
import {Routes, Route, Navigate, useNavigate, Link, Outlet } from 'react-router-dom';
import {Form} from "usetheform";
import useCollapse from 'react-collapsed';
import axios from "axios";
import {loadStripe} from "@stripe/stripe-js";
import {getCatalogProducts, getLogisticProductName, getRestitutionProductsDisplayed, getFormat, getFormatResolutionFullname, getOrderElementsTitle} from "./services/APIService";
import {getTranslation} from "./services/TranslationService";
import {
	getFormatedDate,
	log,
	convertUnicode,
	isExists,
	dateDiffInDays,
	convertToGB,
	getResellerData,
	durationToSeconds
} from "./services/Helpers";
import {Radiobox, Modal} from "./components/Components";
import { useForm } from "react-hook-form";
import { GoogleOAuthProvider,  GoogleLogin } from '@react-oauth/google';
import { isMobile, browserName } from 'react-device-detect';
import TagManager from 'react-gtm-module'
import 'react-slideshow-image/dist/styles.css';

const tagManagerArgs = {
	gtmId: 'GTM-K65QLGN'
}

TagManager.initialize(tagManagerArgs)

const frontUrlA1 = 'https://forever-upsell-v3.netlify.app/';
const frontUrlA3 = 'https://forever-upsell-v2-ia5.netlify.app/';
const apiUrl = 'https://api2.for-ever.com';
const noImageUrl = apiUrl + '/img/iconNoPlay.png';
const def = {
	'margin_total_elements_size_calculation' : 10 / 100,
	'download_alert_size_limit' : 800000000,
	'max_order_size_download_link' : 32,
	'max_single_file_size_hdd_only' : 10
}

const AppContext = React.createContext();

function Footer() {
	return <AppContext.Consumer>
		{() => (
			<footer>
				<div className="pageFooter">
					<div className="centerFooter">
						<div className="contactDetails">
							<div className="wrapContact">
								<p className="XLargeTextRegular contactDetailTitle">Besoin d&#39;aide ou d&#39;informations
									supplémentaires&nbsp;?</p>
								<p className="textRegular contactDetailText">
									Fidèle au poste, Sarah et toute notre équipe sont à votre disposition pour répondre à vos questions ou vous guider à travers le processus.
								</p>
							</div>
							<div className="wrapContact">
								<p className="textRegular contactDetailText">N&#39;hésitez pas à nous joindre par téléphone ou par
									email.</p>
								<div className="contactPhone">
									<img className="iconPhone" alt="icon" src="images/phoneicon.svg" />
										<div className="phoneText">
											<p className="numTelFooter">01 72 72 94 00</p>
											<p className="textRegular contactDetailText">du Lundi au Vendredi de 10h à 18h</p>
										</div>
								</div>
								<div className="contactMail">
									<img className="iconMail" alt="icon" src="images/mailicon.svg" />
										<a className="textRegular contactDetailLink" href="mailto:serviceclient@for-ever.com"
										   target="_blank" rel="noopener noreferrer">serviceclient@for-ever.com</a>
								</div>
							</div>
						</div>
						<div className="lineFooter"></div>
						<div className="mentions">
							<p>Copyright 2024 Devotis&nbsp;-&nbsp;Tous droits réservés -&nbsp;</p>
							<a href="https://fr.for-ever.com/fr/mentions-legales" target="_blank" rel="noopener noreferrer">Mentions
								Légales</a>
							<p>&nbsp;-&nbsp;</p>
							<a href="https://fr.for-ever.com/fr/conditions-generales-vente" target="_blank"
							   rel="noopener noreferrer">CGV</a>
						</div>
					</div>
				</div>
			</footer>
	   )}
	</AppContext.Consumer>
}

function Header() {
	return <AppContext.Consumer>
		{({customer}) => (
			<header>
				<div className="centerHeader">
					<img className="appLogo" alt="logo Forever" src={customer.reseller.logoUrl} />
						<div className="support">
							<div className="lineIconService">
								<img className="supportAgent1" alt="icon" src="images/supportAgent1.svg" />
									<p className="serviceClient">SERVICE CLIENT</p>
							</div>
							<div className="buttonTel">
								<img className="supportAgent2" alt="icon" src="images/supportAgent2.svg" />
									<p className="numTelHeader">01 72 72 94 00</p>
							</div>
						</div>
				</div>
			</header>
		)}
	</AppContext.Consumer>
}

const Orderok = () => {
	return (
		<PrivateLayout>
			<div className="c">
				<h1 className="txt XLargeTextRegular">Confirmation de votre commande</h1>
				<div className="cContent">
					<div className="cTitle">
						<p className="txt XLargeTextRegular txtColorSecondary">Merci pour votre confiance !</p>
						<p className="txt LargeTextRegular txtColorSecondary">Votre commande a été validée avec succès.</p>
					</div>
					<div className="cTexts">
						<p className="txt TextRegular">
							<span>
								Vous allez recevoir un email de confirmation avec tous les détails de votre commande. 
							</span>
							<br/>
							<span>
								Nous sommes ravis de vous aider à préserver et à magnifier vos moments précieux.
							</span>
							<br/>
						</p>
					</div>
				</div>
				<div className="order-back">
					<Link to="/" className="btn btnKey btnOutline txt textRegular">Retour à mes films</Link>

				</div>
			</div>
		</PrivateLayout>
	);
};

class OrderFormat extends React.Component {

	static contextType = AppContext;

	updateOrderFormat(format){
		// Change format in header if all elements have the same format
		let hasSameFormat=true;
		Object.keys(this.context.orders[this.props.order.id].elements).map(key => {
			if(this.context.orders[this.props.order.id].elements[key].selectedformat !== format){
				hasSameFormat=false;
			}
			return hasSameFormat;
		});
	}

	updateLabel(format){
		let hasElementSelected=false;
		Object.keys(this.context.orders[this.props.order.id].elements).map(key => {
			if(this.context.orders[this.props.order.id].elements[key].selectedformat === format){
				hasElementSelected=true;
			}
			return true;
		});
		return hasElementSelected;
	}

	orderCountElementsType(type){
		let countElementType=0;
		Object.keys(this.context.orders[this.props.order.id].elements).map(key => {
			if(type === this.context.orders[this.props.order.id].elements[key].selectedformat){
				countElementType += 1;
			}
		});
		return countElementType;
	}

	constructor(props) {
		super(props);
		this.state = {
			orderImagesElements: [],
			showPopup: false,
			selectedResolution: null
		};
	}

	async componentDidMount() {
		let imgs = [];let images;let i=0;let demo = false;
		let elts = Object.keys(this.context.orders[this.props.order.id].elements);
		elts.map(key => {
			demo = false;
			images = this.context.orders[this.props.order.id].elements[key].image;
			if(this.context.appVersion == 'A3' && this.context.orders[this.props.order.id].elements[key].demos.length > 0) {
				demo = this.context.orders[this.props.order.id].elements[key].demos[0];
			}
			if (images && i < elts.length) {
				if (Array.isArray(images)) {
					// Ancienne structure
					imgs[i] = { mini: images[0], big: images[0], demo };
				} else {
					// Nouvelle structure avec mini / big
					imgs[i] = { mini: images.mini[0], big: images.big[0], demo };
				}
			}
			i++;
		});
		this.setState({
			orderImagesElements: imgs
		});
	}

	closeModal = () => {
		this.setState({
			showPopup: false
		});
	};

	async showModal(res) {
		let demoUrlExists = false;
		if(this.context.appVersion == 'A3' && res.demo){
			demoUrlExists = res.demo[0];
		}
		this.setState({
			showPopup: true,
			modalPic: res.big,
			modalDemo: demoUrlExists
		});
	}

	render() {
		const { order } = this.props;
		let orderId = order.id;
		let estimate = order.estimate;
		let orderElements = this.context.orders[order.id].elements;
		let catalogFormats = this.context.catalog.formats;

		// Étape 1 : obtenir les familles à partir de la commande
		let families = new Set();
		if (order.family === 'mixte') {
			families.add('film');
			families.add('tape');
		} else if (order.family) {
			families.add(order.family);
		}

		// Étape 2 : récupérer tous les formats pour chaque famille
		let allFormats = [];
		families.forEach(family => {
			if (catalogFormats[family]) {
				allFormats.push(...catalogFormats[family]);
			}
		});

		// Étape 3 : extraire les résolutions uniques
		let uniqueResolutions = [...new Set(allFormats.map(f => f.resolution))];

		return	<>
				<div className="thumbnailVideo">
					<div className="io">
						<div className="jh2">
							{
								this.state.orderImagesElements ? this.state.orderImagesElements.map((val, key) =>
									<img key={key} src={val.mini} onClick={() => {this.showModal(val)}}/>
								) :  ''
							}
						</div>
					</div>
					{this.state.modalDemo ?
						<Modal
							shown={this.state.showPopup}
							close={this.closeModal}
						>
							<HeaderModalDemo />
							<div className="relative">
								<video controls autoPlay muted loop width="100%" className="mt5">
									<source src={this.state.modalDemo} type="video/mp4"/>
									Sorry, your browser doesn't support embedded videos.
								</video>
							</div>
						</Modal> :
						<ModalImage
							shown={this.state.showPopup}
							close={this.closeModal}
						>
							<img src={this.state.modalPic} width="100%" height="100%"/>
						</ModalImage>
					}
				</div>
				<div className="wrapQualitySelect">
					<div className="p2e">
						<div className="flexbloc2">
							<div className="flexbloc3">
								<label className={"flexblocLabel " + (this.updateLabel('notselected') ? "active" : "bggrey")}>
									{
										uniqueResolutions.map((res) => (
											<div className="res" key={res}>
												<div className="btnFormat" onClick={() => {
													this.setState({ selectedResolution: res });

													// Reset
													this.context.handleElementFormatClick('notselected', orderId);

													// Appliquer à tous les éléments un format de cette résolution
													Object.entries(orderElements).forEach(([elementId, el]) => {
														const formats = this.context.catalog.formats[el.family];
														const matchingFormat = formats.find(f => f.resolution === res);
														if (matchingFormat) {
															this.context.handleElementFormatClick(matchingFormat['format_id'], orderId, elementId);
														}
													});
												}}>
													<span className={`btnFormat ${this.state.selectedResolution === res ? 'selected' : ''} txt textRegular`}>{getFormatResolutionFullname(res)}</span>
												</div>
												<span className="txt smallTextRegular txtColorPrimary uppercase">
													{(res === 'HD') && 'recommandé'}
												</span>
											</div>
										))
									}
								</label>
							</div>
							<div className="notselectedPrice">
								<label htmlFor={`notselected${orderId}`} className="btnNotselected">
									<span
										onClick={() => {
											this.setState({ selectedResolution: null });
											this.context.handleElementFormatClick('notselected', orderId);
										}}
										className="txt smallTextRegular"><strong className="txt smallTextSemibold">X</strong>Désélectionner
									</span>
								</label>
								<div className="priceItemOrder">
									<div className="txt txtColorSecondary price1">{estimate!= 0 ? estimate.toString().split('.')[0] : '0'}</div>
									<div className="exponent">
										<div className="txt txtColorSecondary price2">{estimate.toString().split('.')[1] ? estimate.toString().split('.')[1] : '00'}€</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
		</>
	}
}

function HeaderModalDemo(){
	return <>
		<div className="km center bold extradarkorange">Extrait de rendu avec intelligence artificielle</div>
		<div className="sp mt15">
			<div className="y">
				<div className="w50p">
					<div className="yt extradarkorange">Avant traitement</div>
				</div>
				<div className="w50p">
					<div className="yt extradarkorange">Après traitement</div>
				</div>
			</div>
		</div>
	</>
}

function ModalImage({ children, shown, close }) {
	return shown ? (
		<div className="modal-backdrop" onClick={() => {close();}}>
			<div className="modal-content"
				 onClick={e => {
					 e.stopPropagation();
				 }}
			>
				<div className="modal-close" onClick={close}>×</div>
				{children}
				<div className="btnCloseModal">
					<div className="btn btnKey btnFillSecondary txt textRegular" onClick={close}>Fermer</div>
				</div>
			</div>
		</div>
	) : null;
}

function Slideshow(props) {
	const timerRef = useRef();
	const [count, setCount] = useState(0);
	const [isreading, setIsreading] = useState(0);

	useEffect(() => () => clearInterval(timerRef.current), []);

	const updateCount = () => {
		if(isreading == 0) {
			setIsreading(1);
			timerRef.current = setInterval(() => {
				setCount((count) => count + 1);
			}, 1000);
		}else{
			clearInterval(timerRef.current);
			setIsreading(0);
		}
	};
	let im = props.src[count % props.src.length];
	let img = im;

	return (
		props.autoread === 'false' ?
			<div>
				<img src={img} />
				<div className="zoom"></div>
			</div>
			:
			<div onClick={updateCount} >
				<img src={img} />
				{isreading==0 && <div className="iconPlayModal"></div>}
			</div>
	);
}

class OrderElement extends React.Component {

	static contextType = AppContext;

	constructor(props) {
		super(props);
		this.state = {
			showPopup: false,
			imgThumbUrl: '',
			isImgExists: true,
			stateDemo: false,
			stateDemoUrls: [],
			stateDemoUrlsMp4: []
		};
		this.videoRef = createRef();
	}

	closeModal = () => {
		if (this.videoRef.current) {
			this.videoRef.current.pause();
			this.videoRef.current.currentTime = 0; // Réinitialise la vidéo dans la modal
		}
		this.setState({
			stateDemo: false
		});
	};

	showIA5DemoModal(orderId, elementId){
		let context = this.context;
		let order = context.orders[orderId];
		let elt;
		context.setHasSeenDemo();
		Object.keys(order.elements).map(async key => {
			if(key == elementId){
				elt = order.elements[key];
				if(elt.demos){
					this.setState({
						stateDemoUrls: elt.demos[0][0],
						stateDemoUrlsMp4: elt.demos[0][2],
						stateDemo: true
					});
				}
			}
		});
	}

	toggleModal() {
		this.setState({
			showPopup: !this.state.showPopup
		});
	}

	async componentDidMount() {
		const { appVersion, element } = this.props;

		// Démo IA (A3) : si un visuel démo existe, on n’affiche pas de vignette
		const demoJpgUrl = (appVersion === 'A3' && element.demos?.[0]?.[1]) || false;

		let imgExists = false;
		let imgGifExists = false;
		let thumbUrl;

		if(appVersion != 'A3' || !demoJpgUrl){
			thumbUrl =  element.image?.mini?.[0] || element.image?.mini;

			const needGif = ['Panier diapo', 'Photos', 'negatif'].includes(element.type) && !!thumbUrl;

			// Vérifs réseau en parallèle
			const [gifOk, imgOk] = await Promise.all([
				needGif ? isExists(thumbUrl + '&type=gif') : Promise.resolve(false),
				thumbUrl ? isExists(thumbUrl) : Promise.resolve(false)
			]);

			imgGifExists = gifOk;
			imgExists = imgOk;
		}

		this.setState({
			imgThumbUrl: imgExists ? thumbUrl : false, //URL de la vignette
			imgGif: imgGifExists, //bool
			demoJpgUrl, //URL de l’image de démo (A3), ou false
			videoLoaded: true //workaround to set video src
		});
	}

	handleImageError = () => {
		const { demoJpgUrl } = this.state;
		// Remplacer "VIDEO04" par "VIDEO03" dans l'URL
		const updatedUrl = demoJpgUrl.replace('VIDEO04', 'VIDEO03');
		this.setState({ demoJpgUrl: updatedUrl });
	}

	render() {
		let orderId = this.props.orderId;
		let elementId = this.props.element.id;
		let elementType = this.props.element.type;
		let selectedFormat = this.context.orders[orderId].elements[elementId].selectedformat;
		let estimate = this.props.element.estimate;
		const queryParams = new URLSearchParams(window.location.search);
		let appFormats = this.context.catalog.formats[this.props.element.family] ?? [];

		if (appFormats.length === 0) return null;

		const imgData = this.props.element.image;
		const modalImages = Array.isArray(imgData?.big) && imgData.big.length ? imgData.big : [];

		return <>
			{ this.props.appVersion === 'A3' && this.state.demoJpgUrl &&
				<div onClick={() => this.showIA5DemoModal(orderId, elementId)}>
					<>
						<div className="mt5 pad2-5">Extrait de rendu avec <b>Intelligence Artificielle</b> pour ce film :</div>
						<img src={this.state.demoJpgUrl} className="w100p pointer" onError={this.handleImageError}  />
					</>
				</div>
			}
			<div className="itemFilm">
				<div className="thumbnailVideo flex-container fc">
					<div className="io" >
						{
							(this.props.appVersion != 'A3' || (this.props.appVersion == 'A3' && !this.state.demoJpgUrl)) ?
								<>
									<div className={this.state.imgThumbUrl ? "jh":"jh cdefault"} onClick={() => {
											if(this.state.imgThumbUrl){
												this.toggleModal(!this.state.showPopup);
											}
										}}>

										{
											this.state.imgThumbUrl &&
											<div className={"jh"} onClick={() => {
												this.toggleModal(!this.state.showPopup);
											}}>
												<img src={this.state.imgThumbUrl || noImageUrl} autoread={'false'}/>
												<img className="iconPlayThumbnail" alt="icon" src="images/play.svg"/>
											</div>
										}
									</div>

									<ModalImage
										shown={this.state.showPopup}
										close={() => {
											this.toggleModal(false);
										}}
									>
										<div className="typeClip txt LargeTextRegular">Images extraites du film original</div>
										<div className="hg">
											{modalImages && modalImages.length > 1 ?
												<Slideshow src={modalImages} autoread={'true'}/>
												: <img src={(modalImages[0] || noImageUrl)} autoread={'true'}/>
											}
										</div>
									</ModalImage>
								</>
								: ""
						}
					</div>
					<div id={"div"+elementId} className="titleFilm">
						<div className="txt smallTitle typeFilm uppercase"> {elementType}</div>
						<div className="txt mediumTextSemibold txtColorPrimary">{convertUnicode(this.props.element.title.trim())}</div>
						{ this.props.appVersion != 'A3' &&
							<div className="typeClip txt verySmallTextRegular">Images extraites du film original</div>
						}
						{ (this.props.appVersion == 'A3' && !(this.state.videoLoaded && this.state.demoJpgUrl)) &&
							<div className="renderingNotAvailable">Extrait de rendu avec Intelligence Artificielle non disponible</div>
						}
						{queryParams.get('dev') && (this.props.element.duration + ", size mp4 original:" + Math.round(this.props.element.size_mp4/1024/1024,2) + "Mo") + ", id: " + elementId}
					</div>
				</div>
				<div className="wrapQualitySelect">
					<div className="p2e">
						<div className="flexbloc2">
							<div className="flexbloc3">
								<div className="flexblocLabel">
									{
										appFormats.map(format => (
											<React.Fragment key={`${format['format_id']}_e${orderId + '-' + elementId}`}>
												<div className="formatLabel">
													<label htmlFor={`${format['format_id']}_e${orderId + '-' + elementId}`} className="btnFormat">
														<Radiobox
															name={`e${orderId + '-' + elementId}`}
															id={`${format['format_id']}_e${orderId + '-' + elementId}`}
															onChange={() => this.context.handleElementFormatClick(format['format_id'], orderId, elementId)}
															checked={selectedFormat === format['format_id']}
														/>
														<span className="btnFormat txt textRegular">
															{format['resolution'] === 'SD' ? 'Qualité standard' :
															format['resolution'] === 'HD' ? 'Qualité Full HD' :
															format['resolution'] === '4k' ? 'Qualité 4K' :
															format['resolution']}
														</span>
													</label>
													<label htmlFor={`${format['format_id']}_e${orderId + '-' + elementId}`} className="CommentBtnFormat">
														<span className="txt smallTextRegular txtColorPrimary uppercase">
															{(format['resolution'] === 'HD') && 'recommandé'}
														</span>
													</label>
												</div>
											</React.Fragment>
										))
									}
								</div>
							</div>

							<div className="notselectedPrice">
								<label htmlFor={`notselected_e${orderId+'-'+elementId}`} className="btnNotselected">
									<Radiobox
										name={`e${orderId+'-'+elementId}`}
										id={`notselected_e${orderId+'-'+elementId}`}
										onChange={() => this.context.handleElementFormatClick('notselected', orderId, elementId)}
										checked={selectedFormat === 'notselected'}
									/>
									<span className="txt smallTextRegular"><strong className="txt smallTextSemibold">X</strong>Désélectionner</span>
								</label>
								<div className="priceItemOrder">
										<div className="txt txtColorSecondary price1">{estimate != 0 ? estimate.toString().split('.')[0] : '0'}</div>
										<div className="exponent">
											<div className="txt txtColorSecondary price2">{estimate.toString().split('.')[1] ? estimate.toFixed(2).toString().split('.')[1] : '00'}€</div>
										</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<Modal
				shown={this.state.stateDemo}
				close={this.closeModal}
			>
				<HeaderModalDemo />
				<div className="relative">
					<video controls autoPlay muted loop width="100%" className="mt5">
						<source src={this.state.stateDemoUrls} type="video/webm"/>
						<source src={this.state.stateDemoUrlsMp4} type="video/mp4" />
						Sorry, your browser doesn't support embedded videos.
					</video>
				</div>
			</Modal>
		</>
	}
}

class ListOrderElements extends React.Component {

	constructor(props) {
		super(props);

		this.listElements = Object.keys(this.props.elements).map(key => {
			return (
				<OrderElement
					key={this.props.elements[key].id}
					element={this.props.elements[key]}
					orderId={this.props.orderId}
					orderFamily={this.props.orderFamily}
					appVersion={props.appVersion}
					orderFormatImg={this.props.orderFormatImg}
				>
				</OrderElement>
			);
		});
	}

	render() {
		return this.listElements
	}
}

function OrderHeader(props){
	const [isExpanded, setExpanded] = useState(true)
	const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded })

	let orderFamily = props.order.family;

	return <AppContext.Consumer>
		{() => (
			<div className={"allOrder " + (isExpanded ? "selectClose" : "selectOpen")}>
				<div className="titleButtonOrder" {...getToggleProps({
					onClick: () => setExpanded((prevExpanded) => !prevExpanded),
				})}>
					<h4 className="lbl-toggle txt titleOrder uppercase">
						Je sélectionne toute ma commande : <span className="txtColorSecondary"><span>{Object.keys(props.order.elements).length}</span> {getOrderElementsTitle(orderFamily)}</span>
					</h4>
					<div className={"btn btnRound " + (isExpanded ? "btnClose" : "btnOpen")}></div>
				</div>
				<div className="collapsible">
					<div className="contentOrder" {...getCollapseProps()}>
						<OrderFormat key={`h${props.order.id}`} appVersion={props.appVersion} order={props.order}></OrderFormat>
					</div>
				</div>
			</div>
		)}
	</AppContext.Consumer>

}
function Order(props) {
	const [isExpanded, setExpanded] = useState(false)
	const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded })

	let orderFamily = props.order.family;

	return <AppContext.Consumer>
		{({lang}) => (
			<div className="orderOptions">
				<div className="wrapTitleOption">
					<div className={"iconOption " + orderFamily}></div>
					<h2 className="txt titleOption">
						Ma commande de <span>{Object.keys(props.order.elements).length}</span> {getOrderElementsTitle(orderFamily)} en {props.order.date}
					</h2>
				</div>
				<div className="boxOrder">
					<label className="LabelBoxOrder" htmlFor={`order${props.order.id}`}>

						<OrderHeader
							key={props.order.id}
							order={props.order}
							appVersion={props.appVersion}
						></OrderHeader>

						<div className={"selectOrder " + (isExpanded ? "selectClose" : "selectOpen")}>
							<div className={"titleButtonOrder " + `btnViewMore${props.order.id} btnView lbl-toggle`} {...getToggleProps({
								onClick: () => setExpanded((prevExpanded) => !prevExpanded),
							})}>
								<h4 className="txt titleOrder uppercase">Je sélectionne {getTranslation(lang, orderFamily + 'SelectItemByItem')}</h4>
								<div className={"btnRound " + (isExpanded ? "btnClose" : "btnOpen")}></div>
							</div>

							<div className="collapsible">
								<div className="contentOrder" {...getCollapseProps()}>
									<ListOrderElements elements={props.order.elements} orderId={props.order.id} orderFamily={props.order.family} appVersion={props.appVersion} orderFormatImg={props.order.formatImg} />
								</div>
							</div>
						</div>
					</label>
				</div>
			</div>
		)}
	</AppContext.Consumer>
}


function RestitutionProduct(props) {
	return <AppContext.Consumer>
		{({addProduct, removeProduct, toggleProduct, products}) => (
			<div className="f2">
				<div className={`wrapProduct ripple ${props.active}`} >
					<div className="typeProduct" onClick={() => toggleProduct(props.product)}>
						<div className="imgProduct">
							{props.product.reference==='output_dematerialized_download' && (
								<img alt="" src="images/illustcopy5.png"/>
							)}
							{['output_physical_usb_key_16', 'output_physical_usb_key_32', 'output_physical_usb_key_64', 'output_physical_usb_key_128'].includes(props.product.reference) && (
								<img alt="" src="images/illustcopy6.png"/>
							)}
							{props.product.reference==='output_physical_hard_disk' && (
								<img alt="" src="images/illustcopy7.png"/>
							)}
							{props.product.reference==='output_physical_hard_disk_2' && (
								<img alt="" src="images/illustcopy7.png"/>
							)}
						</div>
						<div className="titleDescrProduct">
							<div className="titleProduct txt uppercase">{props.product.label}</div>
							{props.product.reference==='output_dematerialized_download' && (
								<p className="descrProduct txt textRegular">
									Je reçois un lien de téléchargement par e-mail afin de récupérer mes fichiers mpeg-4.
								</p>
							)}
							{['output_physical_usb_key_16', 'output_physical_usb_key_32', 'output_physical_usb_key_64', 'output_physical_usb_key_128'].includes(props.product.reference) && (
								<p className="descrProduct txt textRegular">
									Tous mes fichiers mpeg-4 seront transférés sur une clé USB adaptée à la taille de ma commande. Je peux commander cette clé en plusieurs exemplaires.
								</p>
							)}
							{props.product.reference==='output_physical_hard_disk' && (
								<p className="descrProduct txt textRegular">
									Tous mes fichiers mpeg-4 seront transférés sur un disque dur externe de 1 To. Je peux commander ce disque en plusieurs exemplaires.
								</p>
							)}
							{props.product.reference==='output_physical_hard_disk_2' && (
								<p className="descrProduct txt textRegular">
									Tous mes fichiers mpeg-4 seront transférés sur un disque dur externe de 2 To. Je peux commander ce disque en plusieurs exemplaires.
								</p>
							)}
						</div>							
					</div>
					<div className="quantitySelectProduct">
						<div className="quantityProduct">
							{props.product.reference!='output_dematerialized_download' && (
								<>
									<button className="buttonCounter price1 btn btnQuantity" onClick={() => removeProduct(props.product)}>-</button>
									<div className="productCounter">
										<div className="productNber txt price1">
											{
												products.filter(cp => cp.reference === props.product.reference).length > 0 ?
													products.filter(cp => cp.reference === props.product.reference).map(p => p.quantity)
													: 0
											}
										</div>
									</div>
									<button className="buttonCounter price1 btn btnQuantity" onClick={() => addProduct(props.product)}>+</button>
								</>
							)}
						</div>
						<div className="product-rates">
							{
								props.product.prices[0].unit_price == 0 ? <div className="txt txtColorSecondary price1">Gratuit</div> :
									<>
										{
											props.product.prices[0].unit_price.toString().includes('.') ?
												<>
													<div className="txt txtColorSecondary price1">{props.product.prices[0].unit_price.toString().split('.')[0]}</div>
													<div className="exponent">
														<div className="txt txtColorSecondary price2">{props.product.prices[0].unit_price.toString().split('.')[1]}€</div> 
													</div>
												</> :
												<span>props.product.prices[0].unit_price</span>
										}
									</>
							}
						</div>
						<div className="selectProduct">
							{props.product.reference==='output_dematerialized_download' && (
								<button className="buttonCounter" onClick={() => toggleProduct(props.product)}>
									{
										products.filter(cp => cp.reference === props.product.reference).length > 0 ? <div className="btnRound btnOn"><div></div></div> : <div className="btnRound btnOff"><div></div></div>
									}
								</button>
							)}
							{['output_physical_usb_key_16', 'output_physical_usb_key_32', 'output_physical_usb_key_64', 'output_physical_usb_key_128'].includes(props.product.reference) && (
								<button className="buttonCounter" onClick={() => toggleProduct(props.product)}>
									{
										products.filter(cp => cp.reference === props.product.reference).length > 0 ? <div className="btnRound btnOn"><div></div></div> : <div className="btnRound btnOff"><div></div></div>
									}
								</button>
							)}
							{props.product.reference==='output_physical_hard_disk' && (
								<button className="buttonCounter" onClick={() => toggleProduct(props.product)}>
									{
										products.filter(cp => cp.reference === props.product.reference).length > 0 ? <div className="btnRound btnOn"><div></div></div> : <div className="btnRound btnOff"><div></div></div>
									}
								</button>
							)}
							{props.product.reference==='output_physical_hard_disk_2' && (
								<button className="buttonCounter" onClick={() => toggleProduct(props.product)}>
									{
										products.filter(cp => cp.reference === props.product.reference).length > 0 ? <div className="btnRound btnOn"><div></div></div> : <div className="btnRound btnOff"><div></div></div>
									}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>
		)}
	</AppContext.Consumer>
}

class RestitutionProducts extends React.Component {

	static contextType = AppContext

	render() {
		let context = this.context;

		updateCurrentStep(context);

		let alert_download_size = false;
		let elements_number = 0;
		let total_elements_size = 0;
		let any_file_over_10gb = false;
		let elementFormat;
		let str = '------------------------'+'\n';
		let codec = '';
		let resolution = '';
		Object.keys(context.cart).map(k => {
			let product = context.cart[k];
			if(product.size_mp4 || product.size_mpg){
				elements_number += 1;
				let sp = product.reference.split("-");
				let orderId = sp[0];
				let elementId = sp[1];
				elementFormat = sp.pop();

				let ratio = 1;
				context.catalog.formats['film'].every(p => {
					if(p.format_id == elementFormat){
						ratio=p.r_size;
						codec=p.codec;
						resolution=p.resolution;
						return false;
					}
					return true;
				});
				if(ratio == 1){
					context.catalog.formats['tape'].every(p => {
						if(p.format_id == elementFormat){
							ratio=p.r_size;
							codec=p.codec;
							resolution=p.resolution;
							return false;
						}
						return true;
					});
				}
				let product_size_origin, esti, file_size_gb;
				if(resolution=='SD'){
					product_size_origin = codec == 'H264' ? parseInt(product.size_mp4) : parseInt(product.size_mpg);
					esti = 'esti ' + convertToGB(product_size_origin) +'\n';
					total_elements_size += product_size_origin;
					file_size_gb = parseFloat(convertToGB(product_size_origin)) * (1 + def.margin_total_elements_size_calculation);
				}else{ //taille calculée en fonction de la durée (mops = mo/s)
					product_size_origin = parseInt(product.size_mpg);
					let size_f = durationToSeconds(product.duration) / ratio / 1024;
					esti = 'esti ' + size_f +'\n';
					total_elements_size += (size_f * 1024 * 1024 * 1024);
					file_size_gb = size_f * (1 + def.margin_total_elements_size_calculation);
				}
				if (file_size_gb > def.max_single_file_size_hdd_only) {
					any_file_over_10gb = true;
				}
				str += 'order ' + orderId + ', element '+ elementId + ', format ' + elementFormat + ', origin ' + convertToGB(product_size_origin) + ', ' + esti;
			}
		});
		total_elements_size = convertToGB(total_elements_size * (1 + def.margin_total_elements_size_calculation));

		str += 'total size (includes +10%): ' + total_elements_size+' Go.' + '\n';
		str += '------------------------';
		log(str);

		if(total_elements_size > def.download_alert_size_limit){
			alert_download_size = true;
		}

		let restitutionProducts = getRestitutionProductsDisplayed(total_elements_size, context, def, any_file_over_10gb);
		const listProducts = restitutionProducts.map(
			(p) => <RestitutionProduct
				key={p.product_id}
				product={p}
				active={context.products.filter(cp => cp.reference === p.reference).length > 0 ? 'active' : ''}
			>
			</RestitutionProduct>
		);
		let hasDL = restitutionProducts.filter(r => r.reference == 'output_dematerialized_download').length > 0;
		return (
			<>
				<h1 className="txt titlePage">Je choisis mon mode de restitution
					<a className="info-icon" href="#popupExplain">
						<svg className="label-info" width="7" height="17" viewBox="0 0 7 17" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0.574973 14.929C0.574973 14.649 0.609973 14.313 0.679973 13.921C0.749973 13.515 0.812973 13.158 0.868973 12.85L1.93997 7.747L0.469973 7.474L0.616973 6.697L5.04797 5.5L5.38397 5.794L3.80897 13.081C3.71097 13.431 3.66197 13.732 3.66197 13.984C3.66197 14.264 3.78097 14.404 4.01897 14.404C4.34097 14.404 4.84497 13.97 5.53097 13.102L6.16097 13.522C5.88097 13.998 5.54497 14.453 5.15297 14.887C4.77497 15.307 4.33397 15.65 3.82997 15.916C3.33997 16.182 2.79397 16.315 2.19197 16.315C1.70197 16.315 1.30997 16.196 1.01597 15.958C0.721973 15.72 0.574973 15.377 0.574973 14.929ZM4.37597 3.547C3.98397 3.547 3.62697 3.414 3.30497 3.148C2.99697 2.882 2.84297 2.518 2.84297 2.056C2.84297 1.524 3.02497 1.097 3.38897 0.774999C3.75297 0.439 4.17297 0.271 4.64897 0.271C5.09697 0.271 5.46097 0.411 5.74097 0.690999C6.03497 0.956999 6.18197 1.307 6.18197 1.741C6.18197 2.259 5.99997 2.693 5.63597 3.043C5.27197 3.379 4.85197 3.547 4.37597 3.547Z" fill="white"/>
						</svg>
					</a>
				</h1>

				<div className={"msgHelp alert" + (alert_download_size && hasDL ? ' alert-active' : '')}>
					{ elements_number > 1 ?
						<div className="txt textRegular">
							Votre commande contient des <span className="txt textSemibold">fichiers volumineux</span> qui risquent d'être extrêmement longs à télécharger.
						</div>
						: 
						<div className="txt textRegular">
							Votre commande contient un <span className="txt textSemibold">fichier volumineux</span> qui risque d'être extrêmement long à télécharger.
						</div>
					} 
					<div className="txt textRegular">Nous vous recommandons de sélectionner <span className="txt textSemibold">un disque dur ou une clef USB.</span></div>
				</div>

				<div className={"msgHelp alert" + (any_file_over_10gb ? ' alert-active' : '')}>
					<div className="txt textRegular">
						Pour la récupération de vos fichiers vidéo, nous vous recommandons de privilégier un disque dur externe plutôt qu'une clé USB.
						<br />
						Les fichiers vidéo en haute définition (HD) étant très volumineux, leur lecture est généralement plus fluide et plus fiable depuis un disque dur.
						<br />
						Si vous choisissez néanmoins une clé USB, nous vous conseillons de copier les fichiers sur le disque dur de votre ordinateur avant de les visionner, afin d'obtenir une lecture plus fluide. Si vous souhaitez les regarder sur votre téléviseur, il est également recommandé de les transférer sur un disque dur externe personnel, que vous pourrez ensuite raccorder à votre TV.
					</div>
				</div>

				<div className="restitutions">
					{listProducts}
				</div>

				<Logistic/>
			</>
		);
	}
}

function ModalShipping({ children, shown, close }) {

	const {register, handleSubmit, formState: {errors}} = useForm();
	const context = useContext(AppContext);

	const onSubmit = (data, e) => {
		context.customer.lastname = data.lastname;
		context.customer.firstname = data.firstname;
		context.customer.address.address_line1 = data.address_line1;
		context.customer.address.address_line2 = data.address_line2;
		context.customer.address.postcode = data.postcode;
		context.customer.address.country = data.country;
		context.customer.address.town = data.town;
		context.customer.address.phone = data.phone;
		close();
	};
	const onError = (errors, e) => {
		log(errors, e)
	};

	return shown ? (
		<AppContext.Consumer>
			{({customer}) => (
				<div className="modal-backdrop" onClick={close}>
					<div className="modal-content"
						 onClick={e => {
							 // do not close modal if anything inside modal content is clicked
							 e.stopPropagation();
						 }}
					>
						<div className="modal-close" onClick={close}>×</div>
						{children}

						<form className="addressForm" onSubmit={handleSubmit(onSubmit, onError)}>
							<div className="text textRegular">Nom <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.lastname} type="text" {...register("lastname", { required: true })}  />
							{errors.lastname && <span className="error errorAddress">Ce champs est requis</span>}

							<div className="text textRegular">Prénom <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.firstname} type="text" {...register("firstname", { required: true })}  />
							{errors.firstname && <span className="error errorAddress">Ce champs est requis</span>}

							<div className="text textRegular">Adresse <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.address.address_line1} type="text" {...register("address_line1", { required: true })} placeholder="" />
							{errors.address_line1 && <span className="error errorAddress">Ce champs est requis</span>}

							<input className="text textRegular" defaultValue={customer.address.address_line2} type="text" {...register("address_line2")} placeholder="" />

							<div className="text textRegular">Code postal <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.address.postcode} type="text" {...register("postcode", { required: true })} placeholder="" />
							{errors.postcode && <span className="error errorAddress">Ce champs est requis</span>}

							<div className="text textRegular">Ville <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.address.town} type="text" {...register("town", { required: true })} placeholder="" />
							{errors.town && <span className="error errorAddress">Ce champs est requis</span>}

							<div className="text textRegular">Pays <span className="text textRegular red inline">*</span></div>
							<select className="text textRegular" defaultValue={customer.address.country} {...register("country", { required: true })}>
								<option className="text textRegular" value="FRANCE">FRANCE</option>
								<option className="text textRegular" value="BELGIQUE">BELGIQUE</option>
							</select>
							{errors.country && <span className="error errorAddress">Veuillez indiquer votre pays</span>}

							<div className="text textRegular">Téléphone <span className="text textRegular red inline">*</span></div>
							<input className="text textRegular" defaultValue={customer.address.phone} type="text" {...register("phone", { required: true })} placeholder="" />
							{errors.phone && <span className="error errorAddress">Ce champs est requis</span>}

							<input className="btn btnKey btnFillSecondary txt textRegular" type="submit" value="Valider" />
						</form>
					</div>
				</div>
			)}
		</AppContext.Consumer>
	) : null;
}

function LogisticProduct(props) {
	return <AppContext.Consumer>
		{({toggleProduct}) => (
			<div className="f2">
				<div className={`wrapProduct wrapProductLo ripple ${props.active}`} >
					<div className="typeProduct" onClick={() => toggleProduct(props.product)}>
						<div className="imgProduct">
							{props.product.reference == 'logistic_colissimo' &&
								<img alt="icon" src="images/illustDelivery-1.png"/>
							}
							{props.product.reference == 'logistic_ups' &&
								<img alt="icon" src="images/illustDelivery-2.png"/>
							}
							{props.product.reference == 'logistic_gls' &&
								<img alt="icon" src="images/illustDelivery-1.png"/>
							}
							{props.product.reference == 'logistic_tracked' &&
								<img alt="icon" src="images/illustDelivery-1.png"/>
							}
						</div>
						<div className="titleDescrProduct">						
							<div className="titleProduct txt uppercase">
								{getLogisticProductName(props.product)}
							</div>
							<div className="descrProduct txt textRegular">
								{props.product.reference == 'logistic_colissimo' &&
									"L'envoi de votre commande se fera par colis suivi vers votre domicile (votre colis sera déposé au point Poste en cas d'absence)"
								}
								{props.product.reference == 'logistic_ups' &&
									"L'envoi de votre commande se fera par le transporteur UPS vers votre domicile."
								}
								{props.product.reference == 'logistic_gls' &&
									"L'envoi de votre commande se fera par le transporteur GLS vers votre domicile."
								}
								{props.product.reference == 'logistic_tracked' &&
									"L'envoi de votre commande se fera par colis suivi vers votre domicile (votre colis sera déposé au point Poste en cas d'absence)."
								}
							</div>
						</div>
					</div>
					<div className="quantitySelectProduct">					
						<div className="product-rates">
							<div className="txt txtColorSecondary price1">{props.product.prices[0].unit_price.toString().split('.')[0]}</div>
							<div className="exponent">
								<div className="txt txtColorSecondary price2">90€</div> 
							</div>
						</div>
						<div className="selectProduct">
							<div className="btnDelivery">
								<Radiobox 
									name={`${props.product.reference}`}
									id={`${props.product.reference}`}
									checked={props.active}
									onChange={() => toggleProduct(props.product)}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		)}
	</AppContext.Consumer>
}

class Logistic extends React.Component {
	static contextType = AppContext;
	render() {
		let context = this.context;

		updateCurrentStep(context);

		const listProducts = context.catalog.logisticProducts.products.map(
			(p) => <LogisticProduct
				key={p.product_id}
				product={p}
				active={context.products.filter(cp => cp.reference === p.reference).length > 0 ? 'active' : ''}
			>
			</LogisticProduct>
		);
		return (context.hasPhysicalRestitution() &&
			<>
				<h2 className="txt titlePage">Mon mode d'expédition</h2>

				<div className="restitutions">
					{listProducts}
				</div>
			</>
		);
	}
}

class FormThree extends React.Component {

	static contextType = AppContext

	constructor(props) {
		super(props);
		this.state = {
			agreement: false,
			showPopup: false,
			error: '',
			hasSubmitted: false
		};
	}

	componentDidMount() {
		let context = this.context;

		window.scrollTo(0, 0);

		// Add "Frais de traitement" if any
		if(context.catalog.orderFeeProduct){
			context.addProduct(context.catalog.orderFeeProduct);
		}
	}

	handleChange = e => {
		this.setState({ agreement: e.target.checked });
	}

	declareCart(context) {
		return event => {
			if (!this.state.agreement) {
				this.setState({ error: "Vous devez accepter les conditions générales de vente."});
				return false;
			}
			if (!context.customer.address.address_line1) {
				this.setState({ error: "Vous devez ajouter une adresse de livraison."});
				return false;
			}

			if (!this.state.hasSubmitted) {
				this.setState({hasSubmitted: true});

				const url = 'https://api2.for-ever.com/checkout.php';
				let st = JSON.parse(localStorage.getItem('forever-fr-app'));

				let utm_source = '';
				let utm_medium = '';
				let utm_campaign = '';
				if(st['utm']){
					utm_source = st['utm']['utm_source'] ? st['utm']['utm_source'] : '';
					utm_medium = st['utm']['utm_medium'] ? st['utm']['utm_medium'] : '';
					utm_campaign = st['utm']['utm_campaign'] ? st['utm']['utm_campaign'] : '';
				}

				const hash = st['hash'];
				let gid = '';
				if (localStorage.getItem('forever-fr-gid')) {
					let st = JSON.parse(localStorage.getItem('forever-fr-gid'));
					gid = st['gid'];
				}

				const data = {
					appVersion: context.appVersion,
					hash: hash,
					gid: gid,
					customer: context.customer,
					cart: context.cart,
					metadata : {
						'platform' : isMobile ? 'mobile' : 'desktop',
						'browser' : browserName,
						'utm' : {
							'utm_medium' : utm_medium,
							'utm_source' : utm_source,
							'utm_campaign' : utm_campaign
						}
					}
				};

				axios.post(url, data, {
					mode: 'no-cors',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					withCredentials: false
				})
					.then(async sessionId => {
						//const stripe = await loadStripe("pk_test_6C90OYOMzF6s1uEEXVUBGfGz");
						const stripe = await loadStripe("pk_live_51KQvE3FIEoJTI028Jy1kgrl9SHZwl62UKa5pKVFyfyW7SdzGzD095r8pAqW3DhGbMYksQLpHpUX8fa1fPhJg9rOP00X57xpEaF");

						stripe.redirectToCheckout({
							sessionId: sessionId.data
						});
					})
					.catch((error) => {
						log(error);
					});
			}
		}
	}

	getTotal(products){
		let context = this.context;
		let total = 0;
		context.cart.forEach(p => {
			if(products.includes(p.reference)){
				total += p.prices[0].unit_price * p.quantity;
			}
		});
		return total.toFixed(2);
	}

	toggleModal() {
		this.setState({
			showPopup: !this.state.showPopup
		});
	}

	render() {
		let context = this.context;

		updateCurrentStep(context);

		let restitutionCost = this.getTotal(context.catalog.restitutionProducts.refs);
		let logisticCost = this.getTotal(context.catalog.logisticProducts.refs);

		let orderFeeCost = 0;
		if (context.catalog.orderFeeProduct) {
			orderFeeCost = context.catalog.orderFeeProduct.prices[0].unit_price;
		}
		let elementsCost = Math.abs((context.estimate - restitutionCost - logisticCost - orderFeeCost).toFixed(2)) ;

		let formatsSelected = context.getFormatsSelected().map(
			(filesQuantity, formatId) => <div>
				{filesQuantity} fichier(s) {getFormat(context, formatId)}
			</div>
		);
		let restitutionProductsSelected = context.getRestitutionProductsSelected().map(
			(p) => <div>
				{p.label} {p.quantity > 1 && '(x' + p.quantity + ')'}
			</div>
		);
		return (
			<PrivateLayout>
				<div className="viewMain">

					<h1 className="txt titlePage">Je vérifie le Récapitulatif de ma commande
						<a className="info-icon" href="#popupExplain">
							<svg className="label-info" width="7" height="17" viewBox="0 0 7 17" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M0.574973 14.929C0.574973 14.649 0.609973 14.313 0.679973 13.921C0.749973 13.515 0.812973 13.158 0.868973 12.85L1.93997 7.747L0.469973 7.474L0.616973 6.697L5.04797 5.5L5.38397 5.794L3.80897 13.081C3.71097 13.431 3.66197 13.732 3.66197 13.984C3.66197 14.264 3.78097 14.404 4.01897 14.404C4.34097 14.404 4.84497 13.97 5.53097 13.102L6.16097 13.522C5.88097 13.998 5.54497 14.453 5.15297 14.887C4.77497 15.307 4.33397 15.65 3.82997 15.916C3.33997 16.182 2.79397 16.315 2.19197 16.315C1.70197 16.315 1.30997 16.196 1.01597 15.958C0.721973 15.72 0.574973 15.377 0.574973 14.929ZM4.37597 3.547C3.98397 3.547 3.62697 3.414 3.30497 3.148C2.99697 2.882 2.84297 2.518 2.84297 2.056C2.84297 1.524 3.02497 1.097 3.38897 0.774999C3.75297 0.439 4.17297 0.271 4.64897 0.271C5.09697 0.271 5.46097 0.411 5.74097 0.690999C6.03497 0.956999 6.18197 1.307 6.18197 1.741C6.18197 2.259 5.99997 2.693 5.63597 3.043C5.27197 3.379 4.85197 3.547 4.37597 3.547Z" fill="white"/>
							</svg>
						</a>
					</h1>

					<div className="dflex">
						<div className="e1">
							<div className="imgProduct">
								<img alt="marker" src="images/illustAdress.png" />
							</div>
							<div className="shipping_bloc">
								<div className="ys">
									<div className="titleProduct txt uppercase">{context.hasPhysicalRestitution() ? 'Mon adresse de livraison' : 'Mon adresse de facturation'}</div>
									<div className="customerAddress">
										{context.customer.address.address_line1 && (
											<>
												<div className="descrProduct txt textRegular">{context.customer.firstname} {context.customer.lastname}</div>
												<div className="descrProduct txt textRegular">{context.customer.address.address_line1}</div>
												<div className="descrProduct txt textRegular">{context.customer.address.address_line2}</div>
												<div className="descrProduct txt textRegular">{context.customer.address.postcode} {context.customer.address.town}, {context.customer.address.country}</div>
												<div className="descrProduct txt textRegular">{context.customer.address.phone}</div>
											</>
										)}
									</div>
									<div className="btn btnKey btnOutline txt textRegular" onClick={() => {this.toggleModal(!this.state.showPopup);}}>{context.customer.address.address_line1 ? 'Modifier' : 'Ajouter'}</div>
									<ModalShipping
										shown={this.state.showPopup}
										close={() => {
											this.toggleModal(false);
										}}
									>
										<h3 className="titlePopup">Votre adresse de livraison</h3>
									</ModalShipping>
								</div>
							</div>
						</div>
						<div className="e2">
							<div className="imgProduct">
								<img alt="icon" src="images/illustCheck.png" />
							</div>
							<div className="checkOrder_bloc">
								<div className="titleProduct txt uppercase">Ma commande</div>
								<div className="ys v txt textRegular ">
									<div className="descrProduct">
										<span className="txt textRegular">Votre sélection</span>
										<span className="txt price3">{elementsCost} €</span>
									</div>
									<div className="res txt smallTextRegular textItalic txtColorSecondary">{formatsSelected}</div>
									<div className="descrProduct">
										<span className="txt textRegular">Mode de restitution</span>
										<span className="txt price3">{restitutionCost == 0 ? 'GRATUIT' : <>{restitutionCost} €</>}</span>
									</div>
									<div className="res txt smallTextRegular textItalic txtColorSecondary">{restitutionProductsSelected}</div>
									<div className="descrProduct"><span className="txt textRegular">Frais de traitement</span><span className="txt price3">{orderFeeCost} €</span></div>
									{logisticCost != 0 && <>
										<div className="descrProduct">
											<span className="txt textRegular">Livraison</span>
											<span className="txt price3">{logisticCost} €</span>
										</div>
										<div className="res txt smallTextRegular textItalic txtColorSecondary">{getLogisticProductName(context.getLogisticProductSelected())}</div>
									</>}
								</div>
								<div className="checkOrder">
									<div className="descrProduct">
										<span className="txt textRegular">Total</span>
										<div>
											<span className="txt txtColorSecondary price1">{context.estimate.toString()} €</span>
											<span className="txt txtColorSecondary price2"></span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="relative cgv">
						<input type="checkbox"
							   id="cgv"
							   name="cgv"
							   checked={this.state.agreement}
							   onChange={this.handleChange}
						/>
						<label className="checkbox txt textRegular" htmlFor="cgv">
							En cliquant, je reconnais avoir lu et accepté les <a className="txt textRegular" href="#" onClick={()=> window.open("https://fr.for-ever.com/fr/conditions-generales-vente", "_blank")}>Conditions Générales de Services</a>.
						</label>
					</div>

					<Form className="lineValid" onSubmit={this.declareCart(context)}>
						<div className="lineValidwrap1">
							<Link to={'/commande-restitutions'} className="btn btnKey btnOutlineLarge txt textRegular">Retour</Link>
							<div className="lineValidwrap2">
								<button type="submit" className={"btn btnKey btnFillPrimary txt textRegular btn-validate " + (this.state.hasSubmitted ? "btn-disabled" : "") }>{this.state.hasSubmitted ? "Merci de patienter quelques instants..." : "Valider ma commande"}</button>
							</div>
						</div>
						{this.state.error!='' && <p className="help is-danger">{this.state.error}</p>}
					</Form>
				</div>
			</PrivateLayout>
		);
	}
}

function updateCurrentStep(context){
	let currentStep = window.location.pathname;
	let data = {};
	if(localStorage.getItem('forever-fr-app')){
		data = JSON.parse(localStorage.getItem('forever-fr-app'));
	}
	data['step'] = currentStep;

	let contextAuth = context.customer.auth;
	let id = contextAuth.id;
	let hash = contextAuth.hash;
	let referer = contextAuth.referer;

	let utm_source = contextAuth.utm.utm_source;
	let utm_medium = contextAuth.utm.utm_medium;
	let utm_campaign = contextAuth.utm.utm_campaign;

	if(id!='' && hash != ''){
		data['id'] = id;
		data['hash'] = hash;
		data['referer'] = referer;
	}
	data['utm'] = {
		'utm_medium': utm_medium,
		'utm_source': utm_source,
		'utm_campaign': utm_campaign
	}
	localStorage.setItem('forever-fr-app', JSON.stringify(data));
}

function FormTwo() {

	const [error, setError] = useState();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0)
	}, [])

	return <AppContext.Consumer>
		{({hasRestitutionProduct, hasLogisticProduct, hasPhysicalRestitution, estimate}) => (
			<PrivateLayout>
				<div className="viewMain">

					<RestitutionProducts/>

					<div className="lineValid">
						<div className="lineValidwrap1">
							<Link to="/" className="btn btnKey btnOutlineLarge txt textRegular">Retour</Link>
							<div className="lineValidwrap2">
								<div className="lineValidwrap3">
									<div className="txt largeTextRegular txtColorPrimary uppercase">Total</div>
									<div className="lineValidwrap4">
										<div className="txt txtColorPrimary price1">{estimate != 0 ? estimate.toString().split('.')[0] : '0'}</div>
										<div className="exponent">
											<div className="txt txtColorPrimary price2">{estimate != 0 ? estimate.toString().split('.')[1] : '00'}€</div>
											<div className="txt txtColorPrimary price2 displayNone">TTC</div>
										</div>
									</div>
								</div>
								<button className="btn btnKey btnFillPrimary txt mediumTextRegular" onClick={() => {hasRestitutionProduct() ? (hasPhysicalRestitution() ? (hasLogisticProduct() ? navigate('/commande-recapitulatif') : setError('Oups, pour être livré, choisissez simplement votre mode de transport.')) : navigate('/commande-recapitulatif')) : setError('Oups, on dirait que vous avez oublié de choisir comment récupérer vos films ! Quel est votre choix ?')}}>
									Valider
								</button>
							</div>
						</div>
						{error && <p className="msgError txt textRegular">{error}</p>}
					</div>

				</div>
			</PrivateLayout>
		)}
	</AppContext.Consumer>
}

class FormOne extends React.Component {

	static contextType = AppContext

	constructor(props) {
		super(props);
		this.state = {
			stateDemo: false,
			stateDemoUrls: false,
			stateDemoUrlsMp4: false
		};
	}

	getOrderIdFromElementId(orders, element_id_to_find){
		let order_id_='';
		Object.keys(orders).forEach(order_id => {
			let o = orders[order_id];
			for(var element_id in o.elements){
				if(element_id === element_id_to_find){
					order_id_ = order_id;
					break;
				}
			}
		});
		return order_id_;
	}

	componentDidMount() {
		window.scrollTo(0, 0);
	}

	UNSAFE_componentWillMount() {
		let context = this.context;

		updateCurrentStep(context);

		// Opens the order containing the clicked 'element' in the email
		let demoElementId = '';
		if(context.clickOrigin){
			if(context.clickOrigin.indexOf('-') !== -1) {
				demoElementId = context.clickOrigin.split('-')[1];
				let order_id = this.getOrderIdFromElementId(context.orders, demoElementId);

				//Get demo of element
				let order = context.orders[order_id];
				if(order){
					let elt;
					Object.keys(order.elements).map(async key => {
						elt = order.elements[key];
						if(key == demoElementId && elt.demos){
							//show demos pop-in only if we clicked a demo link
							const queryParams = new URLSearchParams(window.location.search);
							if(queryParams.get('t')){
								this.setState({
									stateDemo: true,
									stateDemoUrls: (elt.demos.length>0 && elt.demos[0] ? elt.demos[0][0] : false),
									stateDemoUrlsMp4: (elt.demos.length>0 && elt.demos[0] ? elt.demos[0][2] : false)
								});
							}
						}
					});
				}
			}
		}
	}

	render() {
		return <>
			<Modal
				shown={this.state.stateDemo ? true : false}
				close={() => {
					this.setState({
						stateDemo: false
					});
				}}
			>
				<HeaderModalDemo />
				<div className="relative">
					<video controls autoPlay muted loop width="100%" className="mt5">
						<source src={this.state.stateDemoUrls} type="video/webm"/>
						<source src={this.state.stateDemoUrlsMp4} type="video/mp4" />
						Sorry, your browser doesn't support embedded videos.
					</video>
				</div>
			</Modal>
			<FormOneContent></FormOneContent>
		</>
	}
}

function FormOneContent() {
	const [error, setError] = useState();
	const navigate = useNavigate();
	let hasOrder = false;

	const [showWarningModal, setShowWarningModal] = useState(false);

	const forceContinue = () => {
		setShowWarningModal(false);
		navigate('/commande-restitutions');
	};

	return <AppContext.Consumer>
		{({orders, estimate, hasElements, appVersion, hasSeenDemo}) => (
			<PrivateLayout>
				<div className="viewMain">
					{
						hasOrder = Object.keys(orders).length > 0 ? true : false
					}
					{
						(
							<h1 className="txt titlePage">JE FAIS MA SÉLECTION
							  <a className="info-icon" href="#popupExplain">
								<svg className="label-info" width="7" height="17" viewBox="0 0 7 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M0.574973 14.929C0.574973 14.649 0.609973 14.313 0.679973 13.921C0.749973 13.515 0.812973 13.158 0.868973 12.85L1.93997 7.747L0.469973 7.474L0.616973 6.697L5.04797 5.5L5.38397 5.794L3.80897 13.081C3.71097 13.431 3.66197 13.732 3.66197 13.984C3.66197 14.264 3.78097 14.404 4.01897 14.404C4.34097 14.404 4.84497 13.97 5.53097 13.102L6.16097 13.522C5.88097 13.998 5.54497 14.453 5.15297 14.887C4.77497 15.307 4.33397 15.65 3.82997 15.916C3.33997 16.182 2.79397 16.315 2.19197 16.315C1.70197 16.315 1.30997 16.196 1.01597 15.958C0.721973 15.72 0.574973 15.377 0.574973 14.929ZM4.37597 3.547C3.98397 3.547 3.62697 3.414 3.30497 3.148C2.99697 2.882 2.84297 2.518 2.84297 2.056C2.84297 1.524 3.02497 1.097 3.38897 0.774999C3.75297 0.439 4.17297 0.271 4.64897 0.271C5.09697 0.271 5.46097 0.411 5.74097 0.690999C6.03497 0.956999 6.18197 1.307 6.18197 1.741C6.18197 2.259 5.99997 2.693 5.63597 3.043C5.27197 3.379 4.85197 3.547 4.37597 3.547Z" fill="white"/>
								</svg>
							  </a>
						  	</h1>
						)
					}
					{
						Object.keys(orders).map(key => {
							return <React.Fragment key={key}>
								{
									<Order
										key={key}
										order={orders[key]}
										appVersion={appVersion}
									>
									</Order>
								}
							</React.Fragment>
						})
					}
					{
						<div className="lineValid">
								<div className="lineValidwrap1 WithoutReturn">
									<div className="lineValidwrap2">
										<div className="lineValidwrap3">
											<div className="txt largeTextRegular txtColorPrimary uppercase">Total</div>
											<div className="lineValidwrap4">
												<div className="txt txtColorPrimary price1">{estimate != 0 ? estimate.toString().split('.')[0] : '0'}</div>
												<div className="exponent">
													<div className="txt txtColorPrimary price2">{estimate != 0 ? estimate.toString().split('.')[1] : '00'}€</div>
													<div className="txt txtColorPrimary price2 displayNone">TTC</div>
												</div>
											</div>
										</div>
										<button className="btn btnKey btnFillPrimary txt mediumTextRegular right" onClick={() => {
											if (hasElements()) {
												const hasCassetteVHS = Object.values(orders).some((order) =>
													Object.values(order.elements || {}).some((element) =>
														element.type === 'VHS'
													)
												);
												if (!hasSeenDemo && hasCassetteVHS && appVersion=='A3') {
													setShowWarningModal(true);
													return;
												}
												navigate('/commande-restitutions');
											}else{
												setError('Oups, il semble que vous ayez oublié de sélectionner au moins un film avec son format. Quel est votre choix ?');
											}
										}}>
											Valider
										</button>
									</div>
								</div>
							</div>
					}
					{error && <p className="txt textRegular msgError">{error}</p>}
					{
						!hasOrder && <div className="oupsPage">
							<div className="oupsBackground">
								<div className="oupsContent">
									<p className="txt largeTextSemibold txtColorSecondary">Oups, il semble que vous n'avez pas encore de commande !</p>
									<p className="txt textSemibold">Rendez-vous vite sur <a className="txt textSemibold txtColorPrimary" href="https://fr.for-ever.com" target='_blank'>fr.for-ever.com</a> pour découvrir nos offres en cours.</p>
								</div>
							</div>
						</div>
					}
				</div>
				<Modal shown={showWarningModal} close={() => setShowWarningModal(false)}>
					<div className="modal-content popin-content">
						<h3 className="txt largeTextSemibold mb10">Un petit conseil avant de continuer 😊</h3>
						<p className="txt textRegular mb20 mt10">
							La qualité finale dépend fortement de l'état de votre cassette.
							Pour éviter toute déception, on vous recommande de visionner attentivement les démos avant de choisir l’option HD.<br /><br />
						</p>
						<div className="flex justify-between gap-2">
							<div
								className="btn btnKey btnFillPrimary txt textRegular"
								onClick={() => setShowWarningModal(false)}
							>
								Voir les démos
							</div>
							<br /><br />
							<div
								className="btn btnKey btnOutline txt textRegular"
								onClick={forceContinue}
							>
								Continuer sans voir les démos
							</div>
						</div>
					</div>
				</Modal>

			</PrivateLayout>
		)}
	</AppContext.Consumer>
}

function backdoorGoogleLogin() {
	return <GoogleOAuthProvider
		clientId="499426632005-dargn96ocq4ma99m2h6g7a0q3eg4fv9f.apps.googleusercontent.com">
		<GoogleLogin
			onSuccess={async credentialResponse => {
				log(credentialResponse);
				let accessToken = credentialResponse.credential;
				const data = {
					token: accessToken
				};
				await axios.post(`${apiUrl}/login.php`, data, {
					mode: 'no-cors',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					withCredentials: false
				})
					.then(async response => {
						if(response.data){
							if(response.data != ''){
								localStorage.setItem('forever-fr-gid', JSON.stringify({gid: response.data}));
								window.location.replace(frontUrlA3 + '?id=0009300');
							}
						}
					}).catch((error) => {
						if (error.response) {
							log(error.response);
						}
					});
			}}
			onError={() => {
				log('Login Failed');
			}}
			useOneTap
		/>
	</GoogleOAuthProvider>
}

const ProtectedRoute = ({ isAuthenticated, isLoading, customer }) => {
	if(isLoading){
		return <LoadingPage />
	}
	if(!isAuthenticated) {
		if (customer && customer.email) {
			return <div className="auth err">
				<div className="errBackground">
					<div className="errContent">
						<h1 className="h1 txt">Oups !</h1>
						<h2 className="txt err_info">Authentification expirée</h2>
						<p className="txt largeTextRegular">Nous sommes désolés pour le désagrément. Nous vous invitons à cliquer sur le lien que nous venons d&rsquo;envoyer par email à 
							<u> {customer.email}</u>
						</p>
					</div>
				</div>
				<Footer />
			</div>
		}
	}else if(isAuthenticated === 'backdoor'){
		return backdoorGoogleLogin();
	}else if(isAuthenticated === 'timeout'){
		return <div className="timeout err">
				<div className="errBackground">
					<div className="errContent">
						<h1 className="h1 txt">Maintenance en cours</h1>
						<h2 className="txt err_info">Site temporairement indisponible</h2>
						<p className="txt largeTextRegular">Nous sommes désolés pour le désagrément. Nous vous remercions de votre patience et vous invitons à réessayer ultérieurement.</p>
					</div>
				</div>
				<Footer />
			</div>
	}
	return <Outlet />
};

const NoPage = () => {
	return (
		<div className="noPage err">
			<div className="errBackground">
				<div className="errContent">
					<h1 className="h1 txt titlePage err_404">Oups !</h1>
					<h2 className="txt err_info">La page que vous demandez semble introuvable.</h2>
					<p className="txt largeTextRegular">code erreur : 404</p>
				</div>
			</div>
			<Footer />
		</div>
	)
};

const LoadingPage = () => {
	return <div className="loader"></div>
};

function ModalCart({ children, shown, close }) {
	return shown ? (
		<AppContext.Consumer>
			{({resetCart}) => (
				<div className="modal-backdrop" onClick={close}>
					<div className="modal-content mh170"
						 onClick={e => {
							 // do not close modal if anything inside modal content is clicked
							 e.stopPropagation();
						 }}
					>
						<div className="modal-close" onClick={close}>×</div>
						{children}

						<div className="s12">Retrouvez votre panier avec tous les articles que vous y avez ajoutés !</div>
						<br />
						<div onClick={() => {close();}} className="btn btnKey txt textRegular right mb0 mr0">Vers mon ancien panier <div className="btn2Icon">&#187;</div></div>
						<div onClick={() => {resetCart();close();}} className="btn btnKey txt textRegular btn2 right mb0 mt2 mr20">Je démarre un nouveau panier</div>
					</div>
				</div>
			)}
		</AppContext.Consumer>
	) : null;
}

function ModalCopy() {
	return <div id="popupCopy" className="overlay" onClick={(e) => {
		window.location.hash = "#";
	}}>
		<div className="popup">
			<a className="crossClose" href="#">&times;</a>
			<div className="contentPopup">
				<div className="wrapIntroPopup">
					<div className="textIntroPopup">
						<h3 className="txt titlePopup" >COPIE NUMÉRIQUE</h3>
						<p className="txt textRegular">
							Sauvegardez vos moments inoubliables en format numérique (sous forme de fichiers mpeg-4), <span className="txt textSemibold"></span><span className="txt textSemibold">en choisissant votre qualité de résolution (standard, full HD, 4K)</span>.
						</p>
					</div>
				</div>
				<div className="wrap2Columns">
					<div className="wrap1Column">
						<h4 className="txt titlePopup2 txtColorPrimary">Quels avantages ?</h4>

						<div className="itemPopup">
							<div className="illustcopy illustcopy1"></div>
							<p className="txt textRegular">
								Transmettez facilement à vos proches
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustcopy illustcopy2"></div>
							<p className="txt textRegular">
								Visionnez partout : smartphone, tablette, ordinateur ou télévision connectée
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustcopy illustcopy3"></div>
							<p className="txt textRegular">
								Sauvegardez simplement en ligne ou sur ordinateur
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustcopy illustcopy4"></div>
							<p className="txt textRegular">
								Créez aisément vos propres montages
							</p>
						</div>
					</div>
					<div className="wrap1Column">
						<h4 className="txt titlePopup2 txtColorPrimary">Mode de restitution</h4>
						<div className="itemPopup">
							<div className="illustcopy illustcopy5"></div>
							<p className="txt textRegular">
								Un lien de téléchargement par e-mail pour un accès immédiat et liberté sans support physique.
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustcopy illustcopy6"></div>
							<p className="txt textRegular">
								Une clé USB pour une mobilité et partage en toute simplicité
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustcopy illustcopy7"></div>
							<p className="txt textRegular">
								Un disque dur externe, idéal pour les grands volumes de fichiers
							</p>
						</div>
					</div>
				</div>
				<div className="wrapClose">
					<a className="btn btnKey btnFillSecondary txt textRegular" href="#">Fermer</a>
				</div>
			</div>
		</div>
	</div>
}

function ModalHD() {
	return <div id="popupHD" className="overlay" onClick={(e) => {
		window.location.hash = "#";
	}}>
		<div className="popup">
			<a className="crossClose" href="#">&times;</a>
			<div className="contentPopup">
				<div className="wrapIntroPopup">
					<div className="textIntroPopup">
						<h3 className="titlePopup">QUALITÉ HAUTE DÉFINITION</h3>
						<div className="wraptxt">
							<p className="txt textRegular">
								Grâce à un processus méticuleux et innovant basé sur l&#39;intelligence artificielle (IA), nous sommes désormais en mesure <span className="txt textSemibold">d&#39;améliorer la netteté</span> de vos souvenirs, <span className="txt textSemibold">supprimer la majorité des bruits et imperfections</span> et, bien-sûr, <span className="txt textSemibold">fluidifier les mouvements</span>.
							</p>
						</div>
					</div>
				</div>
				<div className="examplePopup">
					<p className="txt textRegular">Voyez par vous-même le pouvoir transformateur de notre technologie.</p>
					<div className="beforeAfterPopup">
						<div className="BeforePopup">
							<div className="imageBeforePopup"></div>
							<div className="txt textRegular uppercase">AVANT</div>
						</div>
						<div className="AfterPopup">
							<div className="imageAfterPopup"></div>
							<div className="txt textRegular uppercase">APRÈS</div>
						</div>
					</div>
				</div>
				<div className="wrap1Column">
					<div className="wrapFormatPopup">
						<h4 className="txt titlePopup2 txtColorPrimary">Optimisation de votre format</h4>
						<p className="txt textRegular">
							2 formats de fichiers mpeg-4 vous sont proposés :
						</p>
						<div className="itemPopup">
							<div className="illustHD illustHD1"></div>
							<p>
								<span className="txt textSemibold">Le Full HD</span>
								<span className="txt textRegular spaceSpanPopup">
									  (1920 x 1080) offre une clarté remarquable et est recommandé pour la majorité des cas.
									</span>
							</p>
						</div>
						<div className="itemPopup">
							<div className="illustHD illustHD2"></div>
							<p>
									<span className="txt textSemibold">
										L&#39;ultra haute définition 4K
									</span>
								<span className="txt textRegular spaceSpanPopup">
									  (4096 x 2160) assure une immersion totale et convient parfaitement aux passionnés de
									  technologie.
									</span>
							</p>
						</div>
					</div>
				</div>
				<div className="wrapClose">
					<a className="btn btnKey btnFillSecondary txt textRegular center" href="#">Fermer</a>
				</div>
			</div>
		</div>
	</div>
}

function ModalOrderHelp(){
	return <div id="popupExplain" className="overlay" onClick={(e) => {
		window.location.hash = "#";
	}}>
		<div className="popup">
			<a className="crossClose" href="#">&times;</a>
			<div className="contentPopup">
				<div className="wrap2Columns">
					<div className="wrap1Column">
						<div className="wrapIntroPopup2">
							<div className="imgDescripPopup imgDescripPopup3"></div>
							<h3 className="txt titlePopup">Personnaliser votre commande</h3>
						</div>
						<div className="stepP">
							<h4>
								<span className="txt titlePopup2 uppercase txtColorPrimary">étape 1 : </span>
								<span className="txt textSemibold txtColorPrimary">Ma sélection</span>
							</h4>
							<div className="ContentEtape1">
								<div>
									<p className="txt textRegular">Sélectionnez :</p>
									<ul className="txt list textRegular">
										<li><span className="textSemibold">toute votre commande</span></li>
										<li><span className="textSemibold">par supports</span></li>
									</ul>
								</div>
								<div>
									<p className="txt textRegular">Choissisez la qualité :</p>
									<ul className="txt list textRegular">
										<li><span className="textSemibold">Standard</span></li>
										<li><span className="textSemibold">Full HD</span></li>
										<li><span className="textSemibold">4K</span></li>
									</ul>
								</div>
							</div>
							<p className="txt textRegular">NB : le prix varie selon la durée du film</p>
						</div>
					</div>
					<div className="wrap1Column">
						<div className="stepP">
							<h4>
								<span className="txt titlePopup2 uppercase txtColorPrimary">étape 2 : </span>
								<span className="txt textSemibold txtColorPrimary">Ma restitution</span>
							</h4>
							<p className="txt textRegular">
								Choissisez le mode de restitution de vos fichiers :
							</p>
							<ul className="txt list textRegular">
								<li>Recevrez un <span className="textSemibold">lien de téléchargement</span> par e-mail afin de récupérer vos fichiers.</li>
								<li><span className="textSemibold">Clé USB : </span>Vos fichiers seront sur une clé USB adaptée à la taille de votre commande (16, 32 ou 64 Go). Vous pouvez commander cette clé en plusieurs exemplaires.</li>
								<li><span className="textSemibold">Disque dur externe : </span>Tous vos fichiers seront sur un disque dur externe de 1 To. Vous pouvez commander ce disque dur en plusieurs exemplaires.</li>
							</ul>
						</div>
						<div className="stepP">
							<h4>
								<span className="txt titlePopup2 uppercase txtColorPrimary">étape 3 : </span>
								<span className="txt textSemibold txtColorPrimary">Ma commande</span>
							</h4>
							<p className="txt textRegular">Sélectionnez votre mode de transport :</p>
							<ul className="txt list textRegular">
								<li><span className="textSemibold">Courrier suivi : </span>L'envoi se fera par colis suivi vers votre domicile (votre colis sera déposé au point Poste en cas d'absence).</li>
								<li><span className="textSemibold">Logistique UPS : </span>L'envoi de votre commande se fera par UPS vers votre domicile.</li>
							</ul>
							<p className="txt textRegular">Validez votre récapitulatif de commande</p>
						</div>
					</div>
				</div>
				<div className="wrapClose">
					<a className="btn btnKey btnFillSecondary txt textRegular" href="#">Fermer</a>
				</div>
			</div>
		</div>
	</div>
}

const PrivateLayout = ({ children }) => {
	let currentStep = window.location.pathname;

	const context = useContext(AppContext);

	const [demoIa5UrlMp4, setDemoIa5UrlMp4] = useState(null);
	const [demoIa5Url, setDemoIa5Url] = useState(null);
	const [showPopup, setShowPopup] = useState(false);

	const closeModal = () => {
		setShowPopup(false);
	};

	const getDemoIa5Url = async () => {
		let orders = context.orders;
		let demoUrl = false;
		let demoUrlMp4 = false;
		for (const order_key in orders) {
			if (orders.hasOwnProperty(order_key)) {
				for (const key in orders[order_key].elements) {
					if (orders[order_key].elements.hasOwnProperty(key) && orders[order_key].elements[key].demos.length > 0) {
						demoUrl = orders[order_key].elements[key].demos[0];
						demoUrlMp4 = orders[order_key].elements[key].demos[2];
						break;
					}
				}
				if (demoUrl) break;
			}
		}
		//let demoIa5Url = await isExists(demoUrl);
		setDemoIa5Url(demoUrl);
		setDemoIa5UrlMp4(demoUrlMp4);
	}

	const handleImageError = () => {
		const updatedDemoIa5Url = [...demoIa5Url]; // Copie le tableau d'origine
		updatedDemoIa5Url[1] = updatedDemoIa5Url[1].replace('VIDEO04', 'VIDEO03');
		setDemoIa5Url(updatedDemoIa5Url);
	};

	useEffect(()=> {
		if(context.appVersion == 'A3'){
			getDemoIa5Url();
		}
	},[]);

	return (
		<AppContext.Consumer>
			{({customer, showResumeOrder, closeResumeOrder, appVersion, getFirstOrderFamily, orders}) => (
				<div className="mainWrap">
					<ModalCart
						shown={showResumeOrder}
						close={() => {
							closeResumeOrder();
						}}
					>
						<h1 className="h1 titleModal">Votre panier vous attend !</h1>
					</ModalCart>
					<Header/>
					<main>
						<div className="page">
							<div className="wrapHidden wrapHiddenTop">
								<div className="wrapShadow">
									<div className="viewIntro">
										{currentStep == '/' && appVersion === 'A1' &&
											<>
												<div className="welcome">
													<div className="infos txt XLargeTextRegular">Bienvenu(e) {customer.firstname} {customer.lastname}</div>
													<p className="txt largeTextRegular">Sur votre espace personnalisé, découvrez de nouveaux services pour vos précieux souvenirs.</p>
												</div>
												<div className="offerDescriptions">
													<div className="offerDescrip">
														<div className="imgDescrip1"></div>
														<div className="txtDescrip1">
															<div className="txtDescrip">
																<div className="txt XLargeTextRegular">Copie numérique</div>
																<p className="txt textRegular">
																	Recevez une copie numérique de vos souvenirs par lien de téléchargement, sur clé USB ou un disque dur externe.
																</p>
															</div>
															<a className="btn btnKey btnOutline txt textRegular learnMore1" href="#popupCopy">En savoir plus</a>
														</div>
													</div>
													<div className="offerDescrip">
													  <div className="imgDescrip2"></div>
														<div className="txtDescrip2">
															<div className="txtDescrip">
																<div className="txt XLargeTextRegular">Qualité haute définition</div>
																<p className="txt textRegular">Augmentez la définition en Full HD ou en 4K avec l’intelligence artificielle.</p>
															</div>
															<a className="btn btnKey btnOutline txt textRegular learnMore2" href="#popupHD">En savoir plus</a>
														</div>
													</div>
												</div>
											</>
										}
										{currentStep == '/' && appVersion === 'A3' &&
											<div className="welcomeA3">
												<div className="txtIntroA3">
													<p className="infos txt XLargeTextRegular">Bienvenu(e) {customer.firstname} {customer.lastname}</p>

													{ getFirstOrderFamily() == 'film' &&
														<>
															<p className="txt largeTextRegular">
																Découvrez notre service <span className='txt largeTextRegular txtColorPrimary'>PREMIUM</span> en Full HD et 4K.
															</p>
															<p className="txt largeTextRegular">
																Grâce à un procédé innovant mêlant technologie de pointe et intelligence artificielle, nous renforçons aussi la netteté de vos films, éliminons la plupart des bruits et imperfections et fluidifions les mouvements.
															</p>
															<p className="txt largeTextRegular">
																Laissez-vous séduire par une expérience visuelle inégalée en optant pour le Full HD ou la 4K.
															</p>
														</>
													}
													{ getFirstOrderFamily() == 'tape' &&
														<>
															<p className="txt largeTextRegular">
																Découvrez notre service <span className='txt largeTextRegular txtColorPrimary'>PREMIUM</span> en Full HD.
															</p>
															<p className="txt largeTextRegular">
																Grâce à un procédé innovant mêlant technologie de pointe et intelligence artificielle, nous renforçons aussi la netteté des visages.
															</p>
															<p className="txt largeTextRegular">
																Laissez-vous séduire par une expérience visuelle inégalée en optant pour le Full HD.
															</p>
														</>
													}
												</div>

												<Modal
													shown={showPopup}
													close={closeModal}
												>
													<HeaderModalDemo />
													<div className="relative">
													{ demoIa5Url ?
														<video controls autoPlay muted loop width="100%" className="mt5">
															<source src={ demoIa5Url[0] } type="video/mp4"/>
															<source src={ demoIa5Url[0] } type="video/mp4"/>
															Sorry, your browser doesn't support embedded videos.
														</video>
														:
														<div className="beforeAfterA3">
															<div className="BeforeA3">
																<div className="imageBeforeA3"></div>
																<div className="txt textRegular uppercase">AVANT</div>
															</div>
															<div className="AfterA3">
																<div className="imageAfterA3"></div>
																<div className="txt textRegular uppercase">APRÈS</div>
															</div>
														</div>
													}
													</div>
												</Modal>

												{ Object.keys(orders).length > 0 &&
													<>
														<div className="exampleIntroA3">
															 { demoIa5Url ?
																 <img src={demoIa5Url[1]} className="w100p pointer" onClick={() => setShowPopup(true)} onError={handleImageError} />
																:
																<div className="beforeAfterA3">
																	<div className="BeforeA3">
																		<div className="imageBeforeA3"></div>
																		<div className="txt textRegular uppercase">AVANT</div>
																	</div>
																	<div className="AfterA3">
																		<div className="imageAfterA3"></div>
																		<div className="txt textRegular uppercase">APRÈS</div>
																	</div>
																</div>
															}
														</div>
														<div className="wrapFormatA3">
															<div className='itemsA3'>
																<div className="itemA3">
																	<div className="illustHD illustHD1"></div>
																	<p>
																		<span className="txt textSemibold">Le Full HD</span>
																		<span className="txt textRegular spaceSpanA3">
																			(1920 x 1080) offre une clarté remarquable et est recommandé pour la majorité des cas.
																		</span>
																	</p>
																</div>
																{ getFirstOrderFamily() == 'film' &&
																	<div className="itemA3">
																		<div className="illustHD illustHD2"></div>
																		<p>
																			<span className="txt textSemibold">
																				L&#39;ultra haute définition 4K
																			</span>
																			<span className="txt textRegular spaceSpanA3">
																				(4096 x 2160) assure une immersion totale et convient parfaitement aux passionnés de
																				technologie.
																			</span>
																		</p>
																	</div>
																}
															</div>
														</div>
													</>
												}
											</div>
										}
									</div>
								</div>
							</div>
						</div>
						<div className="breadcrumb">
							<div className="wrapHidden">
								<div className="wrapShadow">
									<div className="breadcrumbSteps">
										<div className={"breadStep breadStep1 " + (currentStep === '/' && "breadActive")}>
											<p className={"breadStepP breadStepP1 " + (currentStep === '/' && "breadActive")}>
												<span className="txt largeTextRegular uppercase">étape 1</span>
												<span className="txt textSemibold">Ma sélection</span>
											</p>
										</div>
										<div className={"breadStep breadStep2 " + (currentStep === '/commande-restitutions' && "breadActive")}>
											<p className={"breadStepP breadStepP2 " + (currentStep === '/commande-restitutions' && "breadActive")}>
												<span className="txt largeTextRegular uppercase">étape 2</span>
												<span className="txt textSemibold">Ma restitution</span>
											</p>
										</div>
										<div className={"breadStep breadStep3 " + (currentStep === '/commande-recapitulatif' && "breadActive")}>
											<p className={"breadStepP breadStepP3 " + (currentStep === '/commande-recapitulatif' && "breadActive")}>
												<span className="txt largeTextRegular uppercase">étape 3</span>
												<span className="txt textSemibold">Ma commande</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="page bottomPage">
							<div className="wrapHidden wrapHiddenBottom">
								<div className="wrapShadow">
									{children}
								</div>
							</div>
						</div>
					</main>

					<Footer />

					<ModalCopy />
					<ModalHD />
					<ModalOrderHelp />
				</div>
			)}
		</AppContext.Consumer>
	)
};

class MainComponent extends React.Component {

	componentDidUpdate() {
		log(this.state);
	}
	getCredentials(){
		const queryParams = new URLSearchParams(window.location.search);
		let id = queryParams.get('id') || '';
		let hash = '';
		let clickOrigin = '';

		let utm_source = queryParams.get('utm_source') || '';
		let utm_medium = queryParams.get('utm_medium') || '';
		let utm_campaign = queryParams.get('utm_campaign') || '';
		let utm = {};
		if(utm_source != '' && utm_medium!= ''){
			utm = {
				'utm_medium': utm_medium,
				'utm_source': utm_source,
				'utm_campaign': utm_campaign
			};
		}

		let referer = queryParams.get('referer') || '';
		if(referer == ''){
			if(localStorage.getItem('forever-fr-app')){
				let data = JSON.parse(localStorage.getItem('forever-fr-app'));
				referer = data['referer'];
			}
		}
		// Back-door ------------
		let gid = '';
		if(queryParams.get('k')) { //popup google signin-in
			this.setState({
				isLoading: false,
				isAuthenticated: 'backdoor'
			});
			return '';
		}
		if(localStorage.getItem('forever-fr-gid')){
			let data = JSON.parse(localStorage.getItem('forever-fr-gid'));
			if(data['gid'] !== 'undefined'){
				gid = data['gid'];
			}
			if(id){
				if(data['id'] !== 'undefined' && id!=data['id']) { // New customer
					// reset cart && redirect to step1
					this.resetCart();
				}

				//  save id from queryParams
				data = JSON.parse(localStorage.getItem('forever-fr-gid'));

				// make sure the url has a client_indice (if backdoor access) and not a hash id (upsale_id, used by toutinfo and clients access)
				if(id.length != 7) {
					// backdoor access
					id='0000002'; // default client_indice
				}
				data['id'] = id;
				localStorage.setItem('forever-fr-gid', JSON.stringify(data));

			}else{ //get id from storage
				if(data['id'] !== 'undefined'){
					id = data['id'];
				}
			}
		}else{
			hash = queryParams.get('hash') || '';
			id = queryParams.get('id') || '';
			clickOrigin = queryParams.get('t') || '';
			if(queryParams.get('e')){
				clickOrigin += '-' + queryParams.get('e');
			}

			if (localStorage.getItem('forever-fr-app')) {
				var data = JSON.parse(localStorage.getItem('forever-fr-app'));

				// Prend les param utm du storage s'ils n'existent pas dans l'url
				if (Object.keys(utm).length === 0 && data['utm'] && data['utm']['utm_source'] && data['utm']['utm_medium']){
					utm = data['utm'];
				}

				if(hash == '' || id == ''){
					hash = data['hash'];
					id = data['id'];
				}
			}
		}
		return {
			'id' : id,
			'hash' : hash,
			'gid' : gid,
			'referer' : referer,
			'clickOrigin' : clickOrigin,
			'utm' : utm
		}
	}

	getResellerFavIcon = href => {
		const link = document.createElement("link");
		link.href = href;
		link.rel = "icon";
		link.type = "image/png";
		link.sizes = "16x16";
		document.head.appendChild(link);
	};

	addResellerStylesheet = href => {
		const style = document.createElement("link");
		style.href = href;
		style.rel = "stylesheet";
		style.async = true;
		document.head.appendChild(style);
	};

	async componentDidMount() {

		let credentials = this.getCredentials();
		let id = credentials.id;
		let hash = credentials.hash;
		let gid = credentials.gid;
		let clickOrigin = credentials.clickOrigin;
		let referer = credentials.referer;
		let appVersion = this.props.appVersion;

		const campaign = credentials?.utm?.utm_campaign || "";
		const targetMatch = campaign.match(/-(\d+)$/);
		const target = targetMatch ? parseInt(targetMatch[1], 10) : null;

		if(id && (hash || gid)) {
			const auth_data = {
				hash: hash,
				id: id,
				gid: gid,
				referer: referer,
				appVersion: appVersion,
				platform : isMobile ? 'mobile' : 'desktop',
				browser : browserName,
				utm: credentials.utm
			};
			await axios.post(`${apiUrl}/login.php`, auth_data, {
				mode: 'no-cors',
				timeout: 15000,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded'
				},
				withCredentials: false
			})
				.then(async response => {
					let data = response.data;
					if (data.response_code == 200) {

						let currentStep = window.location.pathname;
						if(currentStep == '/order-ok'){
							// reset cart in storage
							this.resetCart();
						}

						// Get logistic products + restitution products + base product
						let catalog = await getCatalogProducts(appVersion);

						// Get formats
						let formatsFilm = [];
						let formatsTape = [];
						let productsProcess = data.products['process'];
						Object.keys(productsProcess).forEach(family => {
							Object.keys(productsProcess[family]).forEach(format_id => {
								if (format_id === '103' && target === 3) { //supprime SD pour les demandes K7 front
									return; // skip to next iteration
								}
								if(family=='film'){
									formatsFilm.push(productsProcess[family][format_id]);
								} else if(family=='tape') {
									formatsTape.push(productsProcess[family][format_id]);
								}
							});
						});
						catalog.formats = {'film': formatsFilm, 'tape': formatsTape};

						let orders = {};
						let order_id = '';
						let elements = {};
						if (data.orders) {
							let orderEstimate = 0;
							let element_id = '';

							data.orders.forEach(order => {
								order_id = order.order_id;
								elements = {};
								element_id = '';
								orderEstimate = 0;

								order.elements.forEach(element => {

									element_id = element.id;

									elements[element_id] = {
										id: element_id,
										image: element.image,
										title: element.titre,
										duration: element.duration,
										size_mp4: element.size_mp4,
										size_mpg: element.size_mpg,
										type: element.type,
										family: element.family,
										selectedformat: '',
										estimate: 0,
										demos: element.demos,
										prices: element.prices,
										date_num: element.date_num
									}

								});

								Object.keys(elements).map(key => {
									orderEstimate += elements[key].estimate;
								});

								orders[order_id] = {
									id: order_id,
									date: getFormatedDate(order.order_date),
									family: order.family,
									estimate: orderEstimate.toFixed(2),
									elements: elements,
									formatImg: order.format_img
								}
							});

							let resellerData = getResellerData(data.reseller_id);

							if([1, 62, 13, 23].includes(data.reseller_id)){
								this.addResellerStylesheet(resellerData.style);
								document.title = resellerData.pageTitle;
							}
							this.getResellerFavIcon(resellerData.favIconUrl);

							let customer = {
								'id': data.id,
								'firstname': data.shipping_address.firstname,
								'lastname': data.shipping_address.lastname,
								'email': data.email,
								'reseller' : resellerData,
								'address': {
									address_line1: data.shipping_address.line_1,
									address_line2: data.shipping_address.line_2,
									postcode: data.shipping_address.postal_code,
									town: data.shipping_address.city,
									country: data.shipping_address.country,
									phone: data.shipping_address.phone,
								},
								'auth': auth_data
							};

							this.setState({
								cart: [],
								isLoading: false,
								isAuthenticated: true,
								orders: orders,
								customer: customer,
								products: [],
								estimate: 0,
								catalog: catalog,
								clickOrigin: clickOrigin
							});

						} else {
							this.setState({
								isLoading: false
							});
						}
					}else{
						this.setState({
							isLoading: false,
							isAuthenticated: 'timeout',
						});
					}
				})
				.catch((error) => {
					if (error.response) {
						if (error.response.status == 401) {
							let data = error.response.data;
							if (data.email) {
								let customer = {
									'email': data.email
								};
								this.setState({
									isLoading: false,
									isAuthenticated: false,
									customer: customer
								});
							}
						} else{
							this.setState({
								isLoading: false,
								isAuthenticated: false
							});
						}
					} else {
						// Error while retrieving data
						this.setState({
							isLoading: false,
							isAuthenticated: 'timeout',
						});
					}
				});
		}else{
			this.setState({
				isLoading: false
			});
		}
	}
	getOrderEstimate (order) {
		let orderEstimate = 0;
		Object.keys(order.elements).map(key => {
			orderEstimate += order.elements[key].estimate;
			return true;
		});
		// return la somme de tous les estimates des élements d'un order
		return orderEstimate.toFixed(2);
	};
	updateCart (orders, products = []) {
		let estimate = 0;
		let cart = [...products];
		let appversion = this.state.appVersion;

		Object.keys(orders).map(order_key => {
			//log(order_key); //o1, o2, o3...
			let order = orders[order_key];
			Object.keys(order.elements).map(key => {
				let element = order.elements[key];
				if(element.selectedformat != "" && element.selectedformat != "notselected"){
					estimate += this.getElementFormatPrice (element.selectedformat, element);
					let p = {
						"product_id": order.id + '-' + element.id  + '-' + element.selectedformat,
						"reference": order.id + '-' + element.id  + '-' + element.selectedformat,
						"size_mp4": element.size_mp4,
						"size_mpg": element.size_mpg,
						"duration": element.duration,
						"type": element.type,
						"prices": element.prices,
						"date_num": element.date_num
					};
					cart.push(p);
				}
			});
		});

		// add cost of additionnal products
		let price;
		Object.keys(products).map(key => {
			price = products[key].prices[0].unit_price;
			estimate += products[key].quantity ? price * products[key].quantity : price;
		});

		estimate = estimate.toFixed(2);

		// Save the cart in localstorage
		let cart_ap = {};
		cart_ap['content'] = cart;
		cart_ap['lastupdate']= Math.floor(Date.now() / 1000);
		let data_ = JSON.parse(localStorage.getItem('forever-fr-app'));
		let carts = data_['carts'] || {};
		carts[appversion] = cart_ap;
		data_['carts'] = carts;
		localStorage.setItem('forever-fr-app', JSON.stringify(data_));

		this.setState(state => {
			state.cart = cart
			state.products = products
			state.estimate = estimate
			return state
		})
	}; // update cart & estimate with orders & products
	getElementFormatPrice (formatId, element){
		if(formatId && formatId !== 'notselected' && element.prices[formatId]){
			return element.prices[formatId]['total'];
		} else {
			return 0
		}
	}

	constructor(props) {
		super(props);

		this.getFormatsSelected = () => {
			let formatSelected = [];
			let elementFormat='';
			const cart = {...this.state.cart} //create a dummy object
			Object.keys(cart).map(key => {
				if(cart[key].type && cart[key].reference.slice(-11) != "notselected") {
					elementFormat = cart[key].reference.split("-").pop();
					if(formatSelected[elementFormat] !== undefined){
						formatSelected[elementFormat] += 1;
					}else{
						formatSelected[elementFormat] = 1;
					}
				}
			});
			return formatSelected;
		}
		this.getRestitutionProductsSelected = () => {
			const products = {...this.state.products} //create a dummy object
			let restitutionProducts = [];
			let p = [...this.state.catalog.restitutionProducts.refs];
			Object.keys(products).map(key => {
				if(p.includes(products[key].reference)) {
					restitutionProducts.push(products[key]);
				}
			});
			return restitutionProducts;
		}
		this.getLogisticProductSelected = () => {
			const products = {...this.state.products} //create a dummy object
			let logisticProduct = '';
			let p = [...this.state.catalog.logisticProducts.refs];
			Object.keys(products).map(key => {
				if(p.includes(products[key].reference)) {
					logisticProduct = products[key];
				}
			});
			return logisticProduct;
		}
		this.hasLogisticProduct = () => {
			const products = {...this.state.products}
			let r = false;
			Object.keys(products).map(key => {
				if([...this.state.catalog.logisticProducts.refs].includes(products[key].reference)) {
					r=true;
				}
			});
			return r;
		}
		this.hasRestitutionProduct = () => {
			const products = {...this.state.products} //create a dummy object
			let hasR = false;
			let p = [...this.state.catalog.restitutionProducts.refs];
			Object.keys(products).map(key => {
				if(p.includes(products[key].reference)) {
					hasR=true;
				}
			});
			return hasR;
		}
		this.hasPhysicalRestitution = () => {
			const products = {...this.state.products} //create a dummy object
			let hasPhyR = false;

			// get list of physical restitution products
			if(this.state.catalog.length==0){ //if data are not yet received from API
				return false;
			}
			let p = [...this.state.catalog.restitutionProducts.refs];
			p = p.filter(function(item) {
				return item !== 'output_dematerialized_download'
			});

			Object.keys(products).map(key => {
				if(p.includes(products[key].reference)) {
					hasPhyR=true;
				}
			});
			return hasPhyR;
		}
		this.hasElements = () => {
			const cart = {...this.state.cart} //create a dummy object
			let hasElts = false;
			Object.keys(cart).map(key => {
				if(cart[key].type && cart[key].reference.slice(-11) != "notselected") {
					hasElts=true;
				}
			});
			return hasElts;
		}
		this.handleElementFormatClick = (formatId, orderId, elementId) => {
			const orders = { ...this.state.orders };
			const order = orders[orderId];

			const updateElement = (elt) => {
				elt.selectedformat = formatId;
				elt.estimate = (formatId === 'notselected') ? 0 : this.getElementFormatPrice(formatId, elt);
			};

			if (elementId) {
				updateElement(order.elements[elementId]);
			} else {
				Object.values(order.elements).forEach(updateElement);
			}

			order.estimate = this.getOrderEstimate(order);
			this.updateCart(orders);
		}
		this.addProduct = (product) => {
			let products = [...this.state.products];
			if(products.filter(cp => cp.reference === product.reference).length > 0){ // product already present ?
				if(product.reference != 'base_order'){
					// increase quantity
					products = products.map(p =>
						p.reference === product.reference
							? { ...p, quantity: p.quantity + 1 }
							: p
					);
				}
			}else{
				// add new product
				product.quantity = 1;
				products.push(product);
			}
			this.updateCart ({...this.state.orders}, products);
		}
		this.removeProduct = (product) => {
			let products = [...this.state.products];
			if(products.filter(cp => cp.reference === product.reference).length > 0){
				// decrease quantity
				products = products.map(p =>
					p.reference === product.reference
						? { ...p, quantity: Math.max(p.quantity - 1, 0) }
						: p
				);
				// remove product if quantity = 0
				if(products.filter(cp => cp.reference === product.reference).map(p => p.quantity) <= 0){
					products = products.filter(cp => cp.reference != product.reference);
				}
				this.updateCart ({...this.state.orders}, products);
			}
		}
		this.toggleProduct = (product) => {
			let products = [...this.state.products];
			let logisticProductsRefs = [...this.state.catalog.logisticProducts.refs];

			// remove logistic products previously selected
			if(products.filter(cp => (logisticProductsRefs.includes(cp.reference))).length > 0){
				products = products.filter(cp => (logisticProductsRefs.includes(cp.reference)===false));
			}

			if(products.filter(cp => cp.reference === product.reference).length > 0){ // product already present ?
				if(product.reference != 'base_order'){
					products = products.filter(cp => cp.reference != product.reference); // remove product
				}
			}else{
				product.quantity = 1;
				products.push(product); // add product
			}

			this.updateCart ({...this.state.orders}, products);
		};
		this.closeResumeOrder = () => {
			let appversion = this.state.appVersion;
			this.setState({
				showResumeOrder: false,
			});
			if(localStorage.getItem('forever-fr-app')){
				let data = JSON.parse(localStorage.getItem('forever-fr-app'));
				data['carts'][appversion]['lastupdate'] = Math.floor(Date.now() / 1000);
				localStorage.setItem('forever-fr-app', JSON.stringify(data));
			}
		}
		this.resetCart = () => {
			let appversion = this.state.appVersion;
			if(localStorage.getItem('forever-fr-app')){
				let data = JSON.parse(localStorage.getItem('forever-fr-app'));
				data['carts'][appversion]['cart'] = [];
				data['carts'][appversion]['lastupdate'] = Math.floor(Date.now() / 1000);
				localStorage.setItem('forever-fr-app', JSON.stringify(data));
			}
			let orders = {...this.state.orders};
			Object.keys(orders).map(order_key => {
				Object.keys(orders[order_key].elements).map(key => {
					orders[order_key].elements[key].selectedformat = 'notselected';
				});
			});
			this.setState(state => {
				state.cart = []
				state.orders = orders
				state.products = []
				state.lastupdate = Math.floor(Date.now() / 1000)
				state.estimate = 0
				return state
			})
		}

		this.getFirstOrderFamily = () => {
			// Utilisé par app IA5
			// Dès le state loadé, retourne la famille de la dernière commande
			const orders = {...this.state.orders}
			let family = '';
			for (const order_key in orders) {
				if (orders.hasOwnProperty(order_key)) {
					family = orders[order_key].family;
				}
			}
			return family;
		}

		this.setHasSeenDemo = () => {
			this.setState(state => {
				state.hasSeenDemo = true
				return state
			})
		}

		this.state = {
			appVersion: this.props.appVersion,
			isLoading: true,
			isAuthenticated: false,
			orders: null,
			customer: null,
			products: [],
			catalog: [],
			lang: 'fr',
			cart: [],
			estimate: 0,
			hasSeenDemo: false,
			setHasSeenDemo: this.setHasSeenDemo,
			showResumeOrder: false,
			closeResumeOrder: this.closeResumeOrder,
			resetCart: this.resetCart,
			getFirstOrderFamily: this.getFirstOrderFamily,
			getFormatsSelected: this.getFormatsSelected,
			getRestitutionProductsSelected: this.getRestitutionProductsSelected,
			getLogisticProductSelected: this.getLogisticProductSelected,
			hasLogisticProduct: this.hasLogisticProduct,
			hasPhysicalRestitution: this.hasPhysicalRestitution,
			hasRestitutionProduct: this.hasRestitutionProduct,
			hasElements: this.hasElements,
			handleElementFormatClick: this.handleElementFormatClick,
			addProduct: this.addProduct,
			removeProduct: this.removeProduct,
			toggleProduct: this.toggleProduct
		};
	}

	render() {
		return (
			<AppContext.Provider value={this.state}>
				<Routes>
					<Route element={<ProtectedRoute isLoading={this.state.isLoading} isAuthenticated={this.state.isAuthenticated} customer={this.state.customer} />}>
						<Route path="/" element={<FormOne/>} />
						<Route exact path="/commande-restitutions" element={
							this.state.hasElements() ? <FormTwo /> : <Navigate to="/" />
						} />
						<Route exact path="/commande-recapitulatif" element={
							(this.state.hasElements() && this.state.hasRestitutionProduct() && (!this.state.hasPhysicalRestitution() || (this.state.hasLogisticProduct() && this.state.hasPhysicalRestitution()))) ?
								<FormThree /> : <Navigate to="/"  />
						} />
						<Route path="/order-ok" element={<Orderok/>}/>
					</Route>
					<Route path="*" element={<NoPage/>}/>
				</Routes>
			</AppContext.Provider>
		);
	}
}

export default MainComponent;
